export const getTranslatedCardErrorMessages = (t: (key: string) => string) => ({
  emptyCardNumber: t("account.leasePayment.validation.emptyCardNumber"),
  invalidCardNumber: t("account.leasePayment.validation.invalidCardNumber"),
  emptyExpiryDate: t("account.leasePayment.validation.emptyExpiryDate"),
  monthOutOfRange: t("account.leasePayment.validation.monthOutOfRange"),
  yearOutOfRange: t("account.leasePayment.validation.yearOutOfRange"),
  dateOutOfRange: t("account.leasePayment.validation.dateOutOfRange"),
  invalidExpiryDate: t("account.leasePayment.validation.invalidExpiryDate"),
  emptyCVC: t("account.leasePayment.validation.emptyCVC"),
  invalidCVC: t("account.leasePayment.validation.invalidCVC"),
});
